
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 293.775 293.671"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#10111d"}},[_c('path',{attrs:{"data-name":"Path 1","d":"M61.055 139.822a12.45 12.45 0 0112.508-12.452l20.737.068a12.467 12.467 0 0112.467 12.467v78.414c2.336-.692 5.332-1.43 8.614-2.2a10.389 10.389 0 008.009-10.11v-97.266a12.469 12.469 0 0112.468-12.47h20.778a12.469 12.469 0 0112.467 12.467v90.279s5.2-2.106 10.269-4.245a10.408 10.408 0 006.353-9.577V77.57a12.466 12.466 0 0112.466-12.467h20.778a12.468 12.468 0 0112.468 12.467v88.625c18.014-13.055 36.271-28.758 50.759-47.639a20.926 20.926 0 003.185-19.537A146.6 146.6 0 00148.737.013C67.298-1.081-.007 65.398.001 146.847a146.371 146.371 0 0019.5 73.45 18.56 18.56 0 0017.707 9.173 508.86 508.86 0 0014.643-1.518 10.383 10.383 0 009.209-10.306v-77.824"}}),_c('path',{attrs:{"data-name":"Path 2","d":"M60.603 265.58a146.808 146.808 0 00233.172-118.741c0-3.381-.157-6.724-.383-10.049-53.642 80-152.686 117.4-232.79 128.793"}})])])
          )
        }
      }
    